export default __webpack_public_path__ + "static/media/landscape3-Mask-tile.a179c117.png";